(() => {
  const DAY = 864e5;
  const KEY_TS = "emailVisitorTS";
  const KEY_CODE = "emailDiscountCode";
  const KEY_PCT = "emailDiscountPct";
  const now = Date.now();

  function flag() {
    if (document.body) document.body.classList.add("email-visitor");
    else document.addEventListener("DOMContentLoaded", () => document.body.classList.add("email-visitor"));
  }

  let emailVisitor = now - (+localStorage.getItem(KEY_TS) || 0) < DAY;
  let code = localStorage.getItem(KEY_CODE) || "";

  if (!emailVisitor || !code) {
    const u = new URL(location.href);
    const m = location.pathname.match(/\/discount\/([^/?#]+)/i);
    if (!emailVisitor) {
      emailVisitor =
        m ||
        u.searchParams.has("discount") ||
        u.searchParams.has("_kx") ||
        /email/i.test(u.searchParams.get("utm_medium") || "") ||
        /email/i.test(u.searchParams.get("utm_source") || "");
      if (emailVisitor) localStorage.setItem(KEY_TS, now);
    }
    if (!code) {
      code = (m && m[1]) || u.searchParams.get("discount") || "";
      if (code) localStorage.setItem(KEY_CODE, code);
    }
  }

  if (emailVisitor) flag();

  let extraPct = +localStorage.getItem(KEY_PCT) || 0;
  if (!extraPct && code) {
    const el = document.getElementById("discount-codes-json");
    const map = el ? JSON.parse(el.textContent) : {};
    extraPct = map[code] || (code.match(/(\d{1,2})/) ? +RegExp.$1 : 0);
    if (extraPct) localStorage.setItem(KEY_PCT, extraPct);
  }

  const APPLY_EXTRA = emailVisitor && extraPct > 0;

  const langCode = document.documentElement.lang.slice(0, 2);

  function parsePrice(txt) {
    let clean = txt.replace(/[^0-9.,]/g, "");
    clean = clean.replace(/^[.,]+|[.,]+$/g, "");
    if (clean.includes(".") && clean.includes(",")) {
      if (clean.indexOf(".") < clean.lastIndexOf(",")) clean = clean.replace(/\./g, "").replace(",", ".");
      else clean = clean.replace(/,/g, "");
    } else if (clean.includes(",") && !clean.includes(".")) clean = clean.replace(",", ".");
    else if (clean.includes(".") && !clean.includes(",")) {
      if (["da", "nl", "sv"].includes(langCode)) clean = clean.replace(/\./g, "");
    }
    return parseFloat(clean) || 0;
  }

  function getCurrencyParts(priceStr) {
    const text = priceStr.trim();
    return {
      prefix: text.match(/^[^\d]+/)?.[0]?.trim() || "",
      suffix: text.match(/[^\d]+$/)?.[0]?.trim() || ""
    };
  }

  function formatPerBottle(priceStr, divisor, isCompare = false, extra = 0) {
    const { prefix, suffix } = getCurrencyParts(priceStr);
    const cents = parseInt(priceStr.replace(/\D/g, ""), 10) || 0;
    let amount;
    if (langCode === "da") amount = isCompare ? cents : (cents > 1000 ? cents / 100 : cents);
    if (langCode === "sv") amount = isCompare ? cents : (cents > 1000 ? cents : cents);
    else amount = (cents > 4200 ? cents / 100 : cents);
    if (!isCompare && extra > 0) amount = amount * (1 - extra / 100);
    const perUnit = (amount / divisor);
    const rounded = ((perUnit + Number.EPSILON) * 100) / 100;
    const numStr = (rounded % 1 === 0) ? rounded.toFixed(0) : rounded.toFixed(2);
    const truncated = Math.floor(rounded * 100) / 100;
    const formatted = truncated.toString();
    let extraDiscount;
    if (!isCompare && emailVisitor && divisor === 12) {
      extraDiscount = ((rounded * 0.9) % 1 > 0.99) ? (rounded * 0.9).toFixed(0) : (rounded * 0.9).toFixed(2);
    } else {
      extraDiscount = formatted;
    }
    if (["en"].includes(langCode)) {
      return prefix ? prefix + extraDiscount.toString() : extraDiscount.toString() + " " + suffix;
    } else {
      return prefix ? prefix + extraDiscount.toString().replace('.', ',') : extraDiscount.toString().replace('.', ',') + " " + suffix;
    }
  }

  document.querySelectorAll(".variant-name[data-bottles]").forEach(el => {
    const txt = el.dataset.bottles;
    if (txt) el.textContent = txt;
  });

  [
    { sel: ".variant-filter.variant-filter__2 .variant-item", div: 2 },
    { sel: ".variant-filter.variant-filter__3 .variant-item", div: 3 },
    { sel: ".variant-filter.variant-filter__4 .variant-item", div: 6 },
    { sel: ".variant-filter.variant-filter__5 .variant-item", div: 12 }
  ].forEach(({ sel, div }) => {
    const item = document.querySelector(sel);
    const main = item?.querySelector(".main-price");
    const saleEl = item?.querySelector(".sale-price");
    const compEl = item?.querySelector(".compare-price");
    if (!main || !saleEl) return;
    saleEl.textContent = formatPerBottle(main.textContent, div, false, APPLY_EXTRA ? extraPct : 0);
    if (compEl) {
      const raw = item.querySelector("s.compare-at-price")?.textContent;
      if (raw) compEl.textContent = formatPerBottle(raw, div, true, 0);
    }
  });

  [
    ".variant-filter.variant-filter__2 .variant-item",
    ".variant-filter.variant-filter__3 .variant-item",
    ".variant-filter.variant-filter__4 .variant-item",
    ".variant-filter.variant-filter__5 .variant-item"
  ].forEach(sel => {
    const item = document.querySelector(sel);
    const mainEl = item?.querySelector(".main-price");
    const compRaw = item?.querySelector("s.compare-at-price, .compare-at-price");
    const savingsEl = item?.querySelector(".savings");
    if (!mainEl || !compRaw || !savingsEl) return;
    const mainVal = parsePrice(mainEl.textContent.trim());
    const compVal = parsePrice(compRaw.textContent.trim());
    if (compVal <= 0) return;
    const adjustedMain = APPLY_EXTRA ? mainVal * (1 - extraPct / 100) : mainVal;
    let discount = Math.round(Math.abs((compVal - adjustedMain) / compVal * 100));
    discount = Math.max(0, Math.min(100, discount));
    const offSuffix = savingsEl.dataset.offSuffix || "";
    const addOffSuffix = savingsEl.dataset.addOffSuffix || "";
    savingsEl.textContent = `${discount}${offSuffix} ${sel === ".variant-filter.variant-filter__5 .variant-item" ? addOffSuffix : ""}`;
  });

  function updateDataAttr() {
    const checked = document.querySelector(".variant-input:checked");
    const btn = document.getElementById("add-to-cart-button");
    const priceEl = checked && document.querySelector(`label[for="${checked.id}"] .main-price`);
    if (checked && priceEl && btn) {
      let p = priceEl.textContent.trim();
      
      let priceFormatted;
      let priceDiscounted;
      if (emailVisitor && checked.value.includes("360")) {
        const { prefix, suffix } = getCurrencyParts(p);
        priceFormatted = parseInt(p.replace(/\D/g, ""), 10);
        if (["sv"].includes(langCode)) {
          priceDiscounted = (((priceFormatted * 0.9))).toFixed(2).replace('.', ',');
        } else {
          priceDiscounted = (((priceFormatted * 0.9) / 100) + 0.01);
          if (["en"].includes(langCode)) {
            priceDiscounted = priceDiscounted.toFixed(2);
          } else {
            priceDiscounted = priceDiscounted.toFixed(2).replace('.', ',');
          }
        }
        btn.setAttribute("data-price", `${prefix ? prefix + priceDiscounted : priceDiscounted + " " + suffix}`);
      } else {
        btn.setAttribute("data-price", p);
      }
    }
    if (APPLY_EXTRA) updateGlobalSalePrice();
  }

  document.addEventListener("change", e => {
    if (e.target.matches(".variant-input")) updateDataAttr();
  });
  
  updateDataAttr();

  function updateGlobalSalePrice() {
    document.querySelectorAll(".pricing-container .pricing .sale-price").forEach(el => {
      if (!el.dataset.basePrice) {
        el.dataset.basePrice = parsePrice(el.textContent.trim());
        const { prefix, suffix } = getCurrencyParts(el.textContent.trim());
        el.dataset.prefix = prefix;
        el.dataset.suffix = suffix;
      }
      const base = +el.dataset.basePrice;
      const val  = APPLY_EXTRA ? base * (1 - extraPct / 100) : base;
      const num  = (val % 1 === 0) ? val.toFixed(0) : val.toFixed(2);
      el.textContent = el.dataset.prefix ? el.dataset.prefix + num : num + " " + el.dataset.suffix;
    });
  }

  if (APPLY_EXTRA) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", updateGlobalSalePrice);
    else updateGlobalSalePrice();
  }
})();
